import React from 'react';
import Head from 'next/head';
import { injectTestId } from '@cvent/nucleus-test-automation';
import Navigation, { NavigationProps } from './Navigation';

export interface PageHeaderProps extends NavigationProps {
  title: string;
}

function PageHeader({ title, ...navProps }: PageHeaderProps) {
  return (
    <>
      {title && (
        <Head>
          <title key="title">{title}</title>
        </Head>
      )}
      {/* Hidden fixed element to use to scroll to the top of the page in e2e tests */}
      <div {...injectTestId('scrollToTheTop-div')} css={{ height: 1, width: 1, position: 'absolute' }} aria-hidden />
      <Navigation {...navProps} />
    </>
  );
}

export default PageHeader;
